// Pure decision for selecting / deselecting a workflow in the left panel.
// Kept side-effect-free so the toggle behaviour and the always-clear policy
// are unit-testable without rendering <App/>.

/**
 * Resolve the next workflow-selection state.
 *
 * Clicking the currently-active workflow (or clicking nothing) deselects it
 * while staying in workflow mode. Either way the results panel is cleared so a
 * previously-selected workflow's output can't linger beside a different
 * selection — mirroring Run and Select-past-run, which also reset the view.
 * The run itself keeps executing server-side and stays in the sidebar list.
 *
 * @param {string|null|undefined} clickedId - The workflow id that was clicked.
 * @param {string|null} activeWorkflowId - The currently-selected workflow id.
 * @returns {{activeWorkflowId: (string|null), clearResults: boolean,
 *   mode: string}}
 */
export function resolveWorkflowSelection(clickedId, activeWorkflowId) {
  const isDeselect = !clickedId || clickedId === activeWorkflowId;
  return {
    activeWorkflowId: isDeselect ? null : clickedId,
    clearResults: true,
    mode: 'workflow',
  };
}
